import api from "../../api/services/axiosService";
import { USER_MANAGEMENT } from "../../envConstants";

const updateMetadataBaseUrl: any = {
  customBaseUrl: USER_MANAGEMENT,
  isTShots: true,
};

export const updateMetaData = async function (body: any) {
  let res: any = {};
  try {
    res = await api.post(`/user/tatva/metadata`, body, updateMetadataBaseUrl);
  } catch (e) {
    console.error(e);
  }
  return res;
};
